export const LOGIN_ROUTE = '/login';
export const LOGIN_ERROR_ROUTE = '/login_error';
export const LOGIN_SUCCESS_ROUTE = '/login_success';
export const LOGIN_ORG_ROUTE = '/login_org';
export const LOGIN_SILENT = '/login_silent';
export const LOGOUT_ROUTE = '/logout';
export const LOGOUT_SUCCESS_ROUTE = '/logout_success';
export const COMBINED_TOKEN_KEY = 'accessToken';
export const LAST_USED_HUB_STORAGE_KEY = 'lastUsedHub';
export const CENTRAL_INSTANCE_LOGIN_LICENSE_NAME = 'CENTRAL_SERVER_INSTANCE_LOGIN_LI';
export const CENTRAL_INSTANCE_ADMIN_LICENSE_NAME = 'CENTRAL_SERVER_INSTANCE_ADMIN_LI';
export const UUID_REGEX = /[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/i;
export const BENTLEY_SESSION_EXPIRED = 'bentley_login_required';
export const NO_ACCESS = 'no_access';
export const LICENSE_GUARD_FAILURE = 'license_guard_failure';
export const FIREWALL_GUARD_FAILURE = 'firewall_guard_failure';
export const LOGIN_ERROR_MESSAGES = {
    [BENTLEY_SESSION_EXPIRED]: 'Your session has expired, please sign in again.',
    [NO_ACCESS]: 'You do not have access to this resource, please contact an admin in your organisation.',
    [LICENSE_GUARD_FAILURE]: 'We encountered a problem verifying your licenses. Please contact an admin in your organisation if the problem persists.',
    [FIREWALL_GUARD_FAILURE]: "Your current network has not been granted permission to access this resource. Please connect to your organization's network or VPN and try again.",
};
export const LOGIN_ALERT_SEVERITIES = {
    [BENTLEY_SESSION_EXPIRED]: 'info',
    [NO_ACCESS]: 'error',
    [LICENSE_GUARD_FAILURE]: 'error',
    [FIREWALL_GUARD_FAILURE]: 'error',
};
export const SEEQUENT_LOGO_WIDTH = 220;
export const SEEQUENT_LOGO_HEIGHT = 42;
export const GLOBAL_DISCOVERY_DEVELOPMENT_URL = 'https://dev-discover.test.api.seequent.com';
export const GLOBAL_DISCOVERY_INTEGRATION_URL = 'https://uat-discover.test.api.seequent.com';
export const DEV_HUB_URL_STRING = 'dev-sqnt.com';
export const seequentIssuers = [
    'dev-id.test.seequent.com',
    'uat-id.test.seequent.com',
    'id.seequent.com',
];
export const bentleyIssuers = ['qa-ims.bentley.com', 'ims.bentley.com'];
export const EVO_NEXT_SERVICES = ['evo', 'blockmodel'];
export const EVO_APPS = ['blockmodel', 'evo', 'evo-next'];
export const LOGIN_SCOPES = [
    'central.instance:read',
    'central.authz',
    'email',
    'evo.audit',
    'evo.blocksync',
    'evo.discovery',
    'evo.file',
    'evo.object',
    'evo.users:read',
    'evo.workspace',
    'feature_tracking',
    'global_roles',
    'openid',
    'organization',
    'profile',
];
//# sourceMappingURL=constants.js.map